import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

import { URL_IMG } from '../../../configs/urlConfigs';
import { ROUTE_AFFILIATE_REFRESH, PAGENUMROWS_AFFILIATE, SEARCH_TEXT_COUNT, PAGING_END_INDEX, IMPORT_EVENT_LOCATION_CSV_FILE_NAME, DISABLE_LOC_DET_EDIT, ROUTE_AFFILIATE_SETTINGS } from '../../../configs/staticConfigs';
import { MSG_NOT_FOUND, MSG_FILE_FORMAT_ERROR, MSG_REQUIRED, MSG_LOC_ADDED, MSG_LOC_DELETE, MSG_LOC_IMPORT, MSG_FILE_NAME_ERROR, MSG_EVENT_LOC_DELETE_ERROR, MSG_ALREADY_LOC_IMPORTED, MSG_FILE_NAME_STRAT_WITH } from '../../../configs/msgConfigs';
import { LBL_APP_NAME, LBL_SETTINGS, LBL_EVENT_LOCATIONS, LBL_VENUE, LBL_FILTER, LBL_BTN_ADDNEW, LBL_SLNUM, LBL_STREET_1, LBL_STREET_2, LBL_CITY, LBL_STATE, LBL_POST_CODE, LBL_LOCATION, LBL_COUNTRY, LBL_DELETE, LBL_CONFIRM_DELETE, LBL_EVENT, LBL_BACK_TO_SETTINGS } from '../../../configs/labelConfigs';
import * as gLoc from '../../../configs/googleConfigs';

import { eventLocationListAction, eventLocationAddAction, eventLocationDeleteAction, eventLocationImportAction } from '../../../actions/settings/affiliates/locationActions';
import { clearAction, masterLocationListAction } from '../../../actions/commonActions';
import * as types from '../../../actions';

import ModalWindow from '../../commons/helpers/modalWindow';
import Paginator from '../../commons/helpers/paginator';
import Toast from '../../commons/helpers/toast';
import Filter from '../../commons/helpers/filterBy';
import LocationSearchInput from '../../commons/helpers/googleLocationSearch';

import { formValid, csvFileCheck } from '../../../utils/validation';
import { getSortClass, appendVenueLoc } from '../../../utils/commonUtilities';

class EventLocationComponent extends Component {

    constructor(props) {
        super(props)

        this.state = {
            formErrors: {
                locationName: '',
                streetOne: '',
                streetTwo: '',
                city: '',
                state: '',
                country: '',
                postcode: '',
            },
            locationData: {
                locationId: '',
                locationName: null,
                googleLocation: '',
                venue: '',
                streetOne: '',
                streetTwo: '',
                city: null,
                state: null,
                country: null,
                postcode: null
            },
            activePage: 1,
            startIndex: 0,
            endIndex: PAGING_END_INDEX,
            activeRowId: 0,
            perPageCount: PAGENUMROWS_AFFILIATE,
            sortField: 'id', // location__state
            sortOrder: '-',
            toastMessage: '',
            toastFlag: false,
            toastSuccess: true,
            searchLocation: '',
            isFilterOn: false,
            csvFile: '',
            locGoogleCodes: {
                streetOne: '',
                streetTwo: '',
                city: '',
                state: '',
                country: '',
                postcode: '',
            },
            disableLocationSearch: false,
            resetGoogleLocation: 0,
            chkGoogleLocation: 0,
            applyFilter: 0,
            filterClicked: 0,
        }

        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onHandleCsvImport = this.onHandleCsvImport.bind(this);
        this.modalDelete = React.createRef();
        this.modalConfirmDelete = React.createRef();
        this.modal = React.createRef();
        this.csvUploader = React.createRef();
    }

    onShowFilterBy = () => {
        let filterClicked = (this.state.filterClicked + 1);
        this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn, filterClicked: filterClicked }));
        document.getElementById("filterByMenu").classList.toggle('active');
        document.getElementById("filterIcon").classList.toggle('active');

        // this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn })); 
        // document.getElementById("filterByMenu").classList.toggle('active');
        // if(this.state.isFilterOn){
        //    document.getElementById("filterIcon").classList.add('las','la-filter');
        //    document.getElementById("filterIcon").classList.remove('fa','fa-filter');
        // }else{
        //    document.getElementById("filterIcon").classList.remove('las','la-filter');
        //    document.getElementById("filterIcon").classList.add('fa','fa-filter');
        // }
    }

    onApplyFilterButton = () => {

    }

    onHandleCsvImport = () => {
        this.csvUploader.current.click();
    }

    onHandleChange = (e) => {
        const { name } = e.target;
        const value =
            e.target.type === "file" ? e.target.files[0] : e.target.value;

        let formErrors = this.state.formErrors;

        switch (name) {
            // case 'locationName': formErrors.locationName =  value.length <=0  ? MSG_REQUIRED : ""; 
            //     break;  
            // case 'streetOne': formErrors.streetOne =  value.length <=0  ? MSG_REQUIRED : ""; 
            //     break;  
            // case 'streetTwo': formErrors.streetTwo =  value.length <=0 ? MSG_REQUIRED : ""; 
            //     break; 
            case 'city': formErrors.city = value.length <= 0 ? MSG_REQUIRED : "";
                break;
            case 'state': formErrors.state = value.length <= 0 ? MSG_REQUIRED : "";
                break;
            case 'country': formErrors.country = value.length <= 0 ? MSG_REQUIRED : "";
                break;
            case 'postcode': formErrors.postcode = value.length <= 0 ? MSG_REQUIRED : "";
                break;
            default:
                break;
        }

        let locationData = this.state.locationData;

        locationData[name] = value;

        if (e.target.type === "file") {

            // if (!e.target.files[0].name.startsWith(IMPORT_EVENT_LOCATION_CSV_FILE_NAME.split(".csv")[0])) {
            //     this.setToasterState(true, `${MSG_FILE_NAME_ERROR} ${MSG_FILE_NAME_STRAT_WITH} "${IMPORT_EVENT_LOCATION_CSV_FILE_NAME.split(".csv")[0]}"`, false);

            // } else
            if (csvFileCheck(e.target.files[0].name)) {
                const data = new FormData();
                data.append('location_csv', value);
                this.props.eventLocationImportAction(data);
            } else {
                this.setToasterState(true, MSG_FILE_FORMAT_ERROR, false);
            }

        }

        this.setState({ formErrors, locationData });

    }

    onShowActionButtons = (event, rowId) => {

        let dropdown = document.getElementById('dropdown-' + rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-' + rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');

        if (this.state.activeRowId === 0) {
            this.setState({ activeRowId: rowId });
            document.getElementById('img-action-' + rowId).focus();
        } else if (this.state.activeRowId === rowId) {
            this.setState({ activeRowId: 0 });
        } else if (this.state.activeRowId !== rowId) {
            dropdown = document.getElementById('dropdown-' + this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-' + this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({ activeRowId: rowId });
            document.getElementById('img-action-' + rowId).focus();
        }

    }

    onHideActionButtons = (event, rowId) => {
        let dropdown = document.getElementById('dropdown-' + rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-' + rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({ activeRowId: 0 });
    }

    deleteBtnClick = (rowId, name) => {
        let locationData = this.state.locationData;
        locationData['locationId'] = rowId;
        locationData['streetOne'] = name;
        this.setState({ locationData });

        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () => {
        let locationId = this.state.locationData.locationId;
        this.props.eventLocationDeleteAction({ locId: locationId });
    }

    onDeleteConfrimAction = () => {
        let locationId = this.state.locationData.locationId;
        this.props.keyLocationDeleteAction({ locId: locationId, confirm: true });
    }

    onPagePrevious = (e) => {
        const {
            startIndex, endIndex
        } = this.state
        let previousPage = startIndex + 1 - PAGING_END_INDEX
        this.props.eventLocationListAction({ pageSize: this.state.perPageCount, page: previousPage, column: this.state.sortOrder + this.state.sortField, search: this.state.searchLocation });
        if (startIndex === 0) {
            this.setState({
                activePage: previousPage,
                startIndex: startIndex,
                endIndex: endIndex
            });
        } else {
            this.setState({
                activePage: previousPage,
                startIndex: startIndex - PAGING_END_INDEX,
                endIndex: endIndex - PAGING_END_INDEX
            });
        }
    }

    onPageUp = (e) => {


        this.props.eventLocationListAction({ pageSize: this.state.perPageCount, page: e.target.id, column: this.state.sortOrder + this.state.sortField, search: this.state.searchLocation });


        this.setState({
            activePage: Number(e.target.id)
        });
    }

    onPageNext = (e) => {
        const {
            startIndex, endIndex
        } = this.state
        const {
            totalPage
        } = this.props

        let nextPage = startIndex + 1 + PAGING_END_INDEX;
        this.props.eventLocationListAction({ pageSize: this.state.perPageCount, page: nextPage, column: this.state.sortOrder + this.state.sortField, search: this.state.searchLocation });
        if (endIndex === totalPage || totalPage <= PAGING_END_INDEX) {
            this.setState({
                activePage: nextPage,
                startIndex: startIndex,
                endIndex: endIndex
            });
        } else {
            this.setState({
                activePage: nextPage,
                startIndex: startIndex + PAGING_END_INDEX,
                endIndex: endIndex + PAGING_END_INDEX
            });
        }
    }

    onSort = (event, sortKey) => {
        let sOrder = '';
        if (this.state.sortField === sortKey) {
            sOrder = (this.state.sortOrder === '-') ? '' : '-';
            this.props.eventLocationListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: sOrder + this.state.sortField, search: this.state.searchLocation });
            this.setState({ sortOrder: sOrder });
        } else {
            this.setState({ sortField: sortKey });
            this.props.eventLocationListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: this.state.sortOrder + sortKey, search: this.state.searchLocation });
        }
    }

    openModal = () => {
        this.resetFormErrors();
        this.modal.current.handleOpenModal();
    }

    onModalFormReset = () => {
        this.setState({
            locationData: {
                locationId: '',
                locationName: null,
                googleLocation: '',
                venue: '',
                streetOne: '',
                streetTwo: '',
                city: null,
                state: null,
                country: null,
                postcode: null,
                noLocationFound: false
            }
        });
    }

    onModalConfirmReset = () => {
        this.modalDelete.current.handleModelClose();
        this.setState({
            locationData: {
                locationId: '',
                locationName: null,
                googleLocation: '',
                venue: '',
                streetOne: '',
                streetTwo: '',
                city: null,
                state: null,
                country: null,
                postcode: null,
                noLocationFound: false
            }
        });
    }

    resetFormErrors = () => {
        let formErrors = this.state.formErrors;
        formErrors.locationName = '';
        formErrors.streetOne = '';
        formErrors.streetTwo = '';
        formErrors.city = '';
        formErrors.state = '';
        formErrors.country = '';
        formErrors.postcode = '';
        this.setState({ formErrors });
    }

    onSaveFormData = () => {

        if (formValid(this.state)) {

            if (this.state.locationData.locationId) {
                let locationData = {
                    address_id: this.state.locationData.locationId
                }
                this.props.eventLocationAddAction(locationData);
            } else {
                // APPEND VENUE IF IT IS NOT IN THE LOCATION  
                let locName = appendVenueLoc(this.state.locationData.locationName, this.state.locationData.venue);
                let locationData = {
                    location: locName ? locName : '',
                    venue: this.state.locationData.venue ? this.state.locationData.venue : '',
                    street1: this.state.locationData.streetOne ? this.state.locationData.streetOne : '',
                    street2: this.state.locationData.streetTwo ? this.state.locationData.streetTwo : '',
                    city: this.state.locationData.city ? this.state.locationData.city : '',
                    state: this.state.locationData.state ? this.state.locationData.state : '',
                    country: this.state.locationData.country ? this.state.locationData.country : '',
                    postcode: this.state.locationData.postcode ? this.state.locationData.postcode : '',
                    lat_long: this.state.locationData.googleLocation ? this.state.locationData.googleLocation : '',
                }
                this.props.eventLocationAddAction(locationData);
            }

        } else {
            let formErrors = this.state.formErrors;
            if (this.state.locationData.locationName == null) {
                formErrors.locationName = MSG_REQUIRED;
            }
            // if(this.state.locationData.streetOne==null){
            //     formErrors.streetOne = MSG_REQUIRED;
            // }  
            // if(this.state.locationData.streetTwo==null){
            //     formErrors.streetTwo = MSG_REQUIRED;
            // }  
            if (this.state.locationData.city == null) {
                formErrors.city = MSG_REQUIRED;
            }
            if (this.state.locationData.state == null) {
                formErrors.state = MSG_REQUIRED;
            }
            if (this.state.locationData.country == null) {
                formErrors.country = MSG_REQUIRED;
            }
            if (this.state.locationData.postcode == null) {
                formErrors.postcode = MSG_REQUIRED;
            }

            this.setState({ formErrors });
        }

    }


    onCloseToast = () => {
        this.setState({ toastFlag: false, toastMessage: '', toastSuccess: false });
    }

    setToasterState(isEnabled, message, isSucces) {
        this.setState({ toastFlag: isEnabled, toastMessage: message, toastSuccess: isSucces });
        setTimeout(() => {
            this.onCloseToast();
        }, 5000);
    }

    onSearchKeyLocation = (e) => {
        this.setState({ searchLocation: e.target.value })
        this.props.eventLocationListAction({ pageSize: this.state.perPageCount, page: 1, column: this.state.sortOrder + this.state.sortField, search: e.target.value });
    }

    onSearchMasterLocation = (query) => {
        if (query.length >= SEARCH_TEXT_COUNT) {
            this.props.masterLocationListAction(query);
        }

    }

    onSelectLocation = (selected) => {
        if (selected.length > 0) {
            let selectedLoc = selected[0];
            let locationData = this.state.locationData;

            locationData['locationId'] = selectedLoc.id;
            locationData['locationName'] = selectedLoc.location ? selectedLoc.location : '';
            locationData['googleLocation'] = selectedLoc.lat_long ? selectedLoc.lat_long : '';
            locationData['venue'] = selectedLoc.venue ? selectedLoc.venue : '';
            locationData['streetOne'] = selectedLoc.street1 ? selectedLoc.street1 : '';
            locationData['streetTwo'] = selectedLoc.street2 ? selectedLoc.street2 : '';
            locationData['city'] = selectedLoc.city ? selectedLoc.city : '';
            locationData['state'] = selectedLoc.state ? selectedLoc.state : '';
            locationData['country'] = selectedLoc.country ? selectedLoc.country : '';
            locationData['postcode'] = selectedLoc.postcode ? selectedLoc.postcode : '';

            let formErrors = this.state.formErrors;
            formErrors.locationName = '';
            formErrors.streetOne = '';
            formErrors.streetTwo = '';
            formErrors.city = '';
            formErrors.state = '';
            formErrors.country = '';
            formErrors.postcode = '';

            this.setState({ locationData, formErrors });
            // this.resetFormErrors();
        }
        else {
            this.onModalFormReset();
            this.resetFormErrors();
        }
    }

    // IF SOMETHING TYPE IN GOOGLE LOCATION SEARCH, RESET FORM ERROR LOCATION NAME 
    onGoogleLocChange = (address) => {
        if (address && address.trim().length > 0) {
            let formErrors = this.state.formErrors;
            formErrors.locationName = '';
            this.setState({ formErrors });
        }
        else if (!address || address.trim().length === 0) {
            this.setState({
                locationData: {
                    locationId: '',
                    locationName: '',
                    googleLocation: '',
                    venue: '',
                    streetOne: '',
                    streetTwo: '',
                    city: null,
                    state: null,
                    country: null,
                    postcode: null,
                    noLocationFound: true
                }
            });
        }
        this.resetFormErrors();
    }

    setStateUpdate(numRows, totalPage, activity, status, errorData, successData) {
        if (activity === types.EVENT_LOCATION_ADD_SUCCESS) {
            this.modal.current.handleModelClose();
            this.setToasterState(true, MSG_LOC_ADDED, true);
            this.setState({ activePage: 1, startIndex: 0, sortField: 'id', sortOrder: '-' }, () => {
                this.props.eventLocationListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: this.state.sortOrder + this.state.sortField, search: '' });
            })
            // this.props.eventLocationListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:this.state.searchLocation});
        } else if (activity === types.EVENT_LOCATION_ADD_ERROR) {
            let formErrors = this.state.formErrors;
            if (status === 400) {
                if (errorData.hasOwnProperty('location_id')) {
                    formErrors.locationName = errorData.location_id[0];
                    this.setToasterState(true, errorData.location_id[0], false);
                } else {
                    this.modal.current.handleModelClose();
                    this.setToasterState(true, JSON.stringify(errorData), false);
                }
                this.setState(formErrors);
            } else {
                this.modal.current.handleModelClose();
                if (errorData.hasOwnProperty('message')) {
                    this.setToasterState(true, errorData.message, false);
                } else {
                    this.setToasterState(true, JSON.stringify(errorData), false);
                }
            }
        } else if (activity === types.EVENT_LOCATION_DELETE_SUCCESS) {
            this.modalDelete.current.handleModelClose();
            this.modalConfirmDelete.current.handleModelClose();
            if (numRows === 1 && totalPage > 1) {
                let page = this.state.activePage - 1;
                this.props.eventLocationListAction({ pageSize: this.state.perPageCount, page: page, column: this.state.sortOrder + this.state.sortField, search: this.state.searchLocation });
            } else {
                if (this.state.searchLocation.trim().length) {
                    this.setState({ activePage: 1 }, () => {
                        this.props.eventLocationListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: this.state.sortOrder + this.state.sortField, search: this.state.searchLocation });
                    })
                }
                else {
                    this.props.eventLocationListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: this.state.sortOrder + this.state.sortField, search: this.state.searchLocation });
                }
            }
            this.setToasterState(true, MSG_LOC_DELETE, true);
        } else if (activity === types.EVENT_LOCATION_DELETE_ERROR) {
            if (status === 424) {
                this.modalDelete.current.handleModelClose();
                this.setToasterState(true, MSG_EVENT_LOC_DELETE_ERROR, false); // errorData.message
            } else {
                this.modalDelete.current.handleModelClose();
                this.setToasterState(true, JSON.stringify(errorData), false);
            }
        } else if (activity === types.EVENT_LOCATION_IMPORT_SUCCESS) {

            if (successData.record_count === 0) {
                if (successData.mandatory_field_missing && successData.mandatory_field_missing.length > 0) {
                    const missingRows = successData.mandatory_field_missing;
                    const formattedRows = missingRows.length === 2
                        ? `${missingRows[0]} and ${missingRows[1]}`
                        : missingRows.join(", ");

                    const missingFieldsMessage = `Mandatory fields are missing at rows ${formattedRows} in the CSV file.`;
                    this.setToasterState(true, missingFieldsMessage, false);
                } else {
                    this.setToasterState(true, MSG_ALREADY_LOC_IMPORTED, true);
                }
            } else {
                this.setToasterState(true, successData.record_count + ' ' + MSG_LOC_IMPORT, true);
            }
            this.setState({ activePage: 1, startIndex: 0, sortField: 'id', sortOrder: '-' }, () => {
                this.props.eventLocationListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: this.state.sortOrder + this.state.sortField, search: '' });
            })

            document.getElementsByName("csvFile")[0].value = "";

        } else if (activity === types.EVENT_LOCATION_IMPORT_ERROR) {
            this.setToasterState(true, JSON.stringify(errorData), false);
            document.getElementsByName("csvFile")[0].value = "";
        }
    }

    onGetGoogleLoc = (e) => {
        let chkGoogleLocation = 0;
        let resetGoogleLocation = this.state.resetGoogleLocation;
        if (e.target.checked) {
            resetGoogleLocation++;
            chkGoogleLocation = 1;
        }

        const { name } = e.target;
        let { locationData } = this.state;
        locationData[name] = e.target.checked;
        this.typeahead.clear();
        locationData['locationId'] = '';
        locationData['googleLocation'] = '';
        locationData['venue'] = '';
        locationData['streetOne'] = '';
        locationData['streetTwo'] = '';
        locationData['city'] = null;
        locationData['state'] = null;
        locationData['country'] = null;
        locationData['postcode'] = null;

        let formErrors = this.state.formErrors;
        formErrors.locationName = MSG_REQUIRED;
        this.setState({ locationData, formErrors, resetGoogleLocation, chkGoogleLocation });
    }

    googleLocSelect = (address) => {
        let { locationData, formErrors } = this.state;
        let locGoogleCodes = this.state.locGoogleCodes;

        geocodeByAddress(address)
            .then(results => {
                locationData.streetOne = '';
                locationData.streetTwo = '';
                locationData.city = '';
                locationData.state = '';
                locationData.country = '';
                locationData.postcode = '';
                locationData.locationName = results[0].formatted_address;
                let tmpArr = [];
                tmpArr = address.split(',');
                locationData.venue = tmpArr[0];

                locGoogleCodes.streetOne = '';
                locGoogleCodes.streetTwo = '';
                locGoogleCodes.city = '';
                locGoogleCodes.state = '';
                locGoogleCodes.country = '';
                locGoogleCodes.postcode = '';
                //console.log('results: '+JSON.stringify(results[0].formatted_address)); 
                let allAddress = results[0].address_components;
                let addrTypes = [];
                let foundVar = 0;
                let tmpVal = '';
                allAddress.forEach(element => {
                    addrTypes = element.types;
                    foundVar = 0;
                    addrTypes.forEach(item => {
                        tmpVal = element.long_name.trim().length ? element.long_name.trim() : ((element.short_name.trim().length) ? element.short_name.trim() : '');
                        if (foundVar === 0 && tmpVal !== '') {
                            if (gLoc.GOOGLE_LOCATION_STREET.includes(item)) {
                                foundVar = 1;
                                if (locationData['streetOne'].trim() === '') locationData['streetOne'] = tmpVal;
                                else locationData['streetOne'] += ', ' + tmpVal;

                                if (locGoogleCodes['streetOne'].trim() === '') locGoogleCodes['streetOne'] = item;
                                else locGoogleCodes['streetOne'] += ', ' + item;
                            }
                            else if (gLoc.GOOGLE_LOCATION_STREET2.includes(item)) {
                                foundVar = 1;
                                if (locationData['streetTwo'].trim() === '') locationData['streetTwo'] = tmpVal;
                                else locationData['streetTwo'] += ', ' + tmpVal;
                                if (locGoogleCodes['streetTwo'].trim() === '') locGoogleCodes['streetTwo'] = item;
                                else locGoogleCodes['streetTwo'] += ', ' + item;
                            }
                            else if (gLoc.GOOGLE_LOCATION_CITY.includes(item)) {
                                foundVar = 1;
                                if (locationData['city'].trim() === '') locationData['city'] = tmpVal;
                                else locationData['city'] += ', ' + tmpVal;
                                if (locGoogleCodes['city'].trim() === '') locGoogleCodes['city'] = item;
                                else locGoogleCodes['city'] += ', ' + item;
                            }
                            else if (gLoc.GOOGLE_LOCATION_STATE.includes(item)) {
                                foundVar = 1;
                                if (locationData['state'].trim() === '') locationData['state'] = tmpVal;
                                else locationData['state'] += ', ' + tmpVal;
                                if (locGoogleCodes['state'].trim() === '') locGoogleCodes['state'] = item;
                                else locGoogleCodes['state'] += ', ' + item;
                            }
                            else if (gLoc.GOOGLE_LOCATION_COUNTRY.includes(item)) {
                                foundVar = 1;
                                if (locationData['country'].trim() === '') locationData['country'] = tmpVal;
                                else locationData['country'] += ', ' + tmpVal;
                                if (locGoogleCodes['country'].trim() === '') locGoogleCodes['country'] = item;
                                else locGoogleCodes['country'] += ', ' + item;
                            }
                            else if (gLoc.GOOGLE_LOCATION_POSTCODE.includes(item)) {
                                foundVar = 1;
                                if (locationData['postcode'].trim() === '') locationData['postcode'] = tmpVal;
                                else locationData['postcode'] += ', ' + tmpVal;
                                if (locGoogleCodes['postcode'].trim() === '') locGoogleCodes['postcode'] = item;
                                else locGoogleCodes['postcode'] += ', ' + item;
                            }
                        }
                    })
                })

                getLatLng(results[0]).then(latLng => {
                    locationData['googleLocation'] = latLng.lat + ',' + latLng.lng;
                })
            }).then(() => {
                formErrors['locationName'] = '';
                formErrors['streetOne'] = '';
                formErrors['streetTwo'] = '';
                formErrors['city'] = '';
                formErrors['state'] = '';
                formErrors['country'] = '';
                formErrors['postcode'] = '';
                this.setState({ locationData: locationData, locGoogleCodes: locGoogleCodes, formErrors });
            })
            .catch(error => console.error('Error', error));
    }

    renderTooltip(name, props) {
        return (
            <Tooltip id={name} style={{
                opacity: 0.4,
            }} {...props} >
                {name}
            </Tooltip>
        );
    }

    componentDidUpdate(prevProps) {
        const { isFilterOn, numRows, totalPage, status, activity, errorData, successData } = this.props;

        if (isFilterOn !== prevProps.isFilterOn) {
            this.inputFilter.click();
        } else if (activity !== prevProps.activity) {
            this.setStateUpdate(numRows, totalPage, activity, status, errorData, successData);
            this.props.clearAction();
        }
    }

    componentDidMount() {
        document.title = LBL_APP_NAME + " - " + LBL_SETTINGS + " - " + LBL_EVENT_LOCATIONS;
        document.body.classList.add('body-affiliate');
        this.props.eventLocationListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: this.state.sortOrder + this.state.sortField, search: this.state.searchLocation });
    }

    render() {

        const {
            activePage, startIndex, endIndex, toastMessage, toastFlag, toastSuccess, locationData, formErrors, sortField, sortOrder,
        } = this.state

        const { locations, masterLocations, totalPage, status } = this.props;

        if (status === 401 || status === 403) {
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
        }

        //   let disableEditAddress = (!DISABLE_LOC_DET_EDIT && this.state.locationData.locationName && this.state.locationData.locationName.length>0) ? false : true; 

        let disableEditAddress = (!DISABLE_LOC_DET_EDIT && this.state.locationData.locationName && this.state.locationData.locationName.length > 0) ? false : false;

        return (
            <React.Fragment>
                <div className="col-md-12">
                    <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

                    <div className="box">

                        <div className="box-content">
                            <div className="box-head">
                                <div className='divFloatLeft padding-left-1 padding-right-20 padding-top-15 font-14'><Link to={ROUTE_AFFILIATE_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link></div>
                                <div className="dataTables_filter"><label>
                                    <input type="search" className="" placeholder="Search" id="my-search-input" onChange={this.onSearchKeyLocation} /></label>
                                </div>

                                {/* <div  className={this.state.applyFilter ? 'filter-btn-wrapper  text-primary-filter':'filter-btn-wrapper text-primary'}>
                                    <OverlayTrigger
                                        placement="top"
                                        delay={{ show: 450, hide: 250 }}
                                        overlay={<Tooltip id="filterIcon-tooltip" style={{
                                            opacity: 0.4,
                                        }}>
                                        {LBL_FILTER}
                                    </Tooltip>}
                                    >
                                    <button id="filterIcon" ref={input => this.inputFilter = input} onClick={this.onShowFilterBy} className={this.state.applyFilter ? 'filter-btn  text-primary-filter':'filter-btn text-primary'}><i className="las la-filter"></i></button>  
                                    </OverlayTrigger>
                                </div> */}

                                {/* <div className={this.state.applyFilter ? 'filter-btn-wrapper  text-primary-filter':'filter-btn-wrapper text-primary'}>
                                <button ref={input => this.inputFilter = input} onClick={this.onShowFilterBy} className={this.state.applyFilter ? 'filter-btn  text-primary-filter':'filter-btn text-primary'}>
                                    <i id="filterIcon" className="las la-filter"></i>
                                </button>
                                </div> */}

                                {/* <div className="to-right"> 
                                    <button onClick={this.onHandleCsvImport} className="btn btn-outline-primary"><i className="las la-file-import"></i> Import</button>                                
                                    <input name="csvFile" type="file" accept=".csv" id="file" ref={this.csvUploader} onChange={this.onHandleChange} style={{display: "none"}}/>
                                    <button onClick={this.openModal} className="btn btn-primary launch-modal">Add New</button>
                            </div> */}
                                <div className="to-right filter-btn-wrapper" >
                                    <OverlayTrigger
                                        placement="top"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={<Tooltip id="download-tooltip" style={{
                                            opacity: 0.4,
                                        }}>
                                            CSV Import
                                        </Tooltip>}
                                    >
                                        <Link onClick={(e) => this.onHandleCsvImport(e)} className="btn btn-outline-primary filter-btn auto-min-width"><i className="las la-file-import"></i> </Link>

                                    </OverlayTrigger>
                                    <input name="csvFile" type="file" accept=".csv" id="file" ref={this.csvUploader} onChange={this.onHandleChange} style={{ display: "none" }} />
                                    <button onClick={this.openModal} className="btn btn-primary launch-modal">{LBL_BTN_ADDNEW}</button>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table id="data-table" className="table" style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>{LBL_SLNUM}</th>
                                            <th onClick={(e) => this.onSort(e, 'location__location')} className="location-name spanPointer" >{LBL_LOCATION} <i className={sortField == 'location__location' ? getSortClass(1, sortOrder) : getSortClass()}></i></th>
                                            <th onClick={(e) => this.onSort(e, 'location__venue')} className="country  spanPointer" >{LBL_VENUE} <i className={sortField == 'location__venue' ? getSortClass(1, sortOrder) : getSortClass()}></i></th>
                                            <th onClick={(e) => this.onSort(e, 'location__street1')} className="street1 spanPointer">{LBL_STREET_1} <i className={sortField == 'location__street1' ? getSortClass(1, sortOrder) : getSortClass()}></i></th>
                                            <th onClick={(e) => this.onSort(e, 'location__street2')} className="street2 spanPointer">{LBL_STREET_2} <i className={sortField == 'location__street2' ? getSortClass(1, sortOrder) : getSortClass()}></i></th>
                                            <th onClick={(e) => this.onSort(e, 'location__city')} className="city spanPointer">{LBL_CITY} <i className={sortField == 'location__city' ? getSortClass(1, sortOrder) : getSortClass()}></i></th>
                                            <th onClick={(e) => this.onSort(e, 'location__state')} className="state spanPointer">{LBL_STATE} <i className={sortField == 'location__state' ? getSortClass(1, sortOrder) : getSortClass()}></i></th>
                                            <th onClick={(e) => this.onSort(e, 'location__country')} className="country spanPointer">{LBL_COUNTRY} <i className={sortField == 'location__country' ? getSortClass(1, sortOrder) : getSortClass()}></i></th>
                                            <th onClick={(e) => this.onSort(e, 'location__postcode')} className="postcode spanPointer">{LBL_POST_CODE} <i className={sortField == 'location__postcode' ? getSortClass(1, sortOrder) : getSortClass()}></i></th>
                                            <th className="action">&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(this.props.count === 0) &&
                                            <tr>
                                                <td colSpan="10" className="text-center">{MSG_NOT_FOUND}</td>
                                            </tr>
                                        }
                                        {locations.map((item, index) => {

                                            let indeNum = (PAGENUMROWS_AFFILIATE * (activePage - 1)) + index + 1;

                                            return (
                                                <tr key={item.id}>

                                                    <td>{indeNum}</td>
                                                    <td>{item.location.location}</td>
                                                    <td>{item.location.venue}</td>
                                                    <td>{item.location.street1}</td>
                                                    <td>{item.location.street2}</td>
                                                    <td>{item.location.city}</td>
                                                    <td>{item.location.state}</td>
                                                    <td>{item.location.country}</td>
                                                    <td>{item.location.postcode}</td>
                                                    <td>
                                                        <div className="dropdown" id={'dropdown-' + item.id}>
                                                            <button className="dropdown-toggle" type="button"
                                                                id={'dropdownMenuButton-' + item.id} data-toggle="dropdown"
                                                                aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)} >
                                                                <input type="image" id={"img-action-" + item.id} src={require('../../../' + URL_IMG + 'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                            </button>
                                                            <div className="dropdown-menu" id={'dropdown-menu-' + item.id}
                                                                aria-labelledby={'dropdownMenuButton-' + item.id}>

                                                                <Link className="dropdown-item delete"
                                                                    to="#" onMouseDown={(e) => this.deleteBtnClick(item.id, item.location.street1)}>{LBL_DELETE}</Link>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>

                                            )
                                        })

                                        }
                                    </tbody>
                                </table>
                                <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext} />
                                <div className="clear-b-scroll">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                    <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                        {"Are you sure you want to delete " + LBL_EVENT + " Location '" + locationData.streetOne + "'?"}
                    </ModalWindow>

                    <ModalWindow ref={this.modalConfirmDelete} header={LBL_CONFIRM_DELETE} type="confirm" deleteConfirmedItem={this.onDeleteConfrimAction} resetModalForm={this.onModalConfirmReset}>
                        This event location has already been used in another module, do you still want to delete this record?
                    </ModalWindow>

                    <ModalWindow ref={this.modal} header={"Add " + LBL_EVENT + " Location"} saveFormData={(e) => this.onSaveFormData()} resetModalForm={this.onModalFormReset}>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Search location</label>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <div className="custom-checkbox">
                                        <input type="checkbox" id="noLocationFound" name="noLocationFound" onChange={this.onGetGoogleLoc} checked={locationData.noLocationFound} disabled={this.state.disableLocationSearch} value={this.state.chkGoogleLocation} />
                                        <label className="checkbox" htmlFor="noLocationFound"></label>
                                        <label className="labeltext" htmlFor="noLocationFound">Couldn't find the location? Get it from Google
                                            <sup>
                                                <OverlayTrigger
                                                    placement="top"
                                                    delay={{ show: 250, hide: 400 }}
                                                    overlay={this.renderTooltip('Type address to get the location from google map')}
                                                >
                                                    <button type="button" className="tootltip-btn">
                                                        <i className="las la-question-circle"></i>
                                                    </button>
                                                </OverlayTrigger>
                                            </sup>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <div className={locationData.noLocationFound ? 'hide' : 'text-input'} >
                                        <AsyncTypeahead
                                            className={formErrors.locationName.length > 0 ? "input-error" : ''}
                                            isLoading={false}
                                            name="locationName"
                                            id="locationSearch"
                                            minLength={SEARCH_TEXT_COUNT}
                                            labelKey="location"
                                            onChange={selected => this.onSelectLocation(selected)}
                                            options={masterLocations}
                                            placeholder="Type a location..."
                                            onSearch={this.onSearchMasterLocation}
                                            searchText="Searching"
                                            promptText="Type a location..."
                                            disabled={this.state.disableLocationSearch}
                                            ref={(ref) => this.typeahead = ref}
                                            inputProps={{ className: this.state.formErrors.locationName.length > 0 ? "input-error" : '' }}
                                        />
                                        {/* {this.state.formErrors.locationName.length >0 && (
                                    <div className="text-red left-align text-12">{this.state.formErrors.locationName}</div>
                                    )}  */}
                                    </div>
                                    <div className={locationData.noLocationFound ? 'text-input' : 'hide'} >
                                        <LocationSearchInput
                                            name="googleLocation"
                                            googleLocSelect={this.googleLocSelect}
                                            disabled={this.state.disableLocationSearch}
                                            resetLocNameErr='yes'
                                            onGoogleLocChange={this.onGoogleLocChange}
                                            resetGoogleLocation={this.state.resetGoogleLocation}
                                            className={this.state.formErrors.locationName.length > 0 ? " input-error" : ''} />
                                        {/* {this.state.formErrors.locationName.length >0 && (
                                    <div className="text-red left-align text-12">{this.state.formErrors.locationName}</div>
                                    )}  */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{LBL_VENUE} </label>
                                    <div className="text-input">
                                        <input type="text" placeholder={LBL_VENUE} name="venue" onChange={this.onHandleChange} value={locationData.venue || ''} maxLength={125} disabled={disableEditAddress} />
                                        {/* disabled={!locationData.noLocationFound} */}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    &nbsp;
                                </div>
                            </div>
                        </div>

                        {/* <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Search location</label>                   
                                    <AsyncTypeahead
                                        className={formErrors.locationName.length >0 ? "input-error" : ''}
                                        isLoading={false}
                                        name="locationName" 
                                        id="locationSearch"
                                        minLength={SEARCH_TEXT_COUNT}
                                        labelKey="location"
                                        onChange={selected => this.onSelectLocation(selected)}
                                        options={masterLocations}
                                        placeholder="Type a location..."
                                        onSearch={this.onSearchMasterLocation}
                                    />
                                    {this.state.formErrors.locationName.length >0 && (
                                        <div className="text-red left-align text-12">{this.state.formErrors.locationName}</div>
                                    )} 
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Couldn't find the location? Get it from Google<sup>
                                <button type="button" className="tootltip-btn" data-toggle="tooltip" data-placement="top" title="Type address to get the location from google map">
                                    <i className="la la-question-circle"></i>
                                </button></sup>  </label>
                                <div className="text-input"><input type="text" placeholder=" " name="googleLocation" /></div>
                            </div>
                        </div>
                    </div> */}

                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Street1</label>
                                    <div className="text-input"><input type="text" placeholder=" " name="streetOne" onChange={this.onHandleChange} className={disableEditAddress ? "disabledElement" : ''} value={locationData.streetOne || ''} maxLength={120} disabled={disableEditAddress} /></div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Street2</label>
                                    <div className="text-input"><input type="text" placeholder=" " name="streetTwo" onChange={this.onHandleChange} className={disableEditAddress ? "disabledElement" : ''} value={locationData.streetTwo || ''} maxLength={120} disabled={disableEditAddress} /></div>
                                </div>
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>City</label>
                                    <div className="text-input"><input type="text" placeholder=" " name="city" onChange={this.onHandleChange} value={locationData.city || ''} maxLength={120} className={(formErrors.city.length > 0 ? "input-error" : ' ') + ' ' + (disableEditAddress ? " disabledElement " : '')} disabled={disableEditAddress} /></div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>State</label>
                                    <div className="text-input"><input type="text" placeholder=" " name="state" onChange={this.onHandleChange} value={locationData.state || ''} maxLength={120} className={(formErrors.state.length > 0 ? "input-error" : ' ') + ' ' + (disableEditAddress ? " disabledElement " : '')} disabled={disableEditAddress} /></div>
                                </div>
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Country</label>
                                    <div className="text-input"><input type="text" placeholder=" " name="country" onChange={this.onHandleChange} value={locationData.country || ''} maxLength={120} className={(formErrors.country.length > 0 ? "input-error" : ' ') + ' ' + (disableEditAddress ? " disabledElement " : '')} disabled={disableEditAddress} /></div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Post code</label>
                                    <div className="text-input"><input type="text" placeholder=" " name="postcode" onChange={this.onHandleChange} value={locationData.postcode || ''} maxLength={10} className={(formErrors.postcode.length > 0 ? "input-error" : ' ') + ' ' + (disableEditAddress ? " disabledElement " : '')} disabled={disableEditAddress} /></div>
                                </div>
                            </div>

                        </div>
                    </ModalWindow>
                </div>
                <Filter onApplyFilterButton={this.onApplyFilterButton} >
                    <div className="filter-category">
                        <h4>Street 1</h4>
                        <div className="form-group">
                            <div className="form-group text-input">
                                <input type="text" placeholder="Street 1" />
                            </div>
                        </div>
                    </div>
                    <div className="filter-category">
                        <h4>Street 2</h4>
                        <div className="form-group">
                            <div className="form-group text-input">
                                <input type="text" placeholder="Street 2" />
                            </div>
                        </div>
                    </div>
                    <div className="filter-category">
                        <h4>City</h4>
                        <div className="form-group">
                            <div className="select-input">
                                <select >
                                    <option>Select City</option>
                                    <option>Option 1</option>
                                    <option>Option 2</option>
                                    <option>Option 3</option>
                                    <option>Option 4</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="filter-category">
                        <h4>State</h4>
                        <div className="form-group">
                            <div className="select-input">
                                <select >
                                    <option>Select State</option>
                                    <option>Option 1</option>
                                    <option>Option 2</option>
                                    <option>Option 3</option>
                                    <option>Option 4</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="filter-category">
                        <h4>Country</h4>
                        <div className="form-group">
                            <div className="select-input">
                                <select >
                                    <option>Select Country</option>
                                    <option>Option 1</option>
                                    <option>Option 2</option>
                                    <option>Option 3</option>
                                    <option>Option 4</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="filter-category">
                        <h4>Post Code</h4>
                        <div className="form-group">
                            <div className="form-group text-input">
                                <input type="text" placeholder="Post Code" />
                            </div>
                        </div>
                    </div>

                </Filter>
            </React.Fragment>

        )
    }

}
const mapStateToProps = (state) => {
    return {
        locations: state.eventLocations.items,
        totalPage: state.eventLocations.totalPage,
        status: state.eventLocations.status,
        activity: state.eventLocations.activity,
        numRows: state.eventLocations.numRows,
        count: state.eventLocations.count,
        masterLocations: state.eventLocations.masterLocations,
        errorData: state.eventLocations.errorData,
        successData: state.eventLocations.successData,
        isFilterOn: state.commons.isFilterOn
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        eventLocationListAction: eventLocationListAction,
        eventLocationAddAction: data => eventLocationAddAction(data),
        eventLocationDeleteAction: id => eventLocationDeleteAction(id),
        masterLocationListAction: id => masterLocationListAction(id),
        eventLocationImportAction: data => eventLocationImportAction(data),
        clearAction: clearAction
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(EventLocationComponent);